/**
 * `/metal-solutions/industries/packaging-and-processing-equipment/`: the old URL of the page now at
 * `/metal-solutions/industries/industrial-automation` (`../industrial-automation/index.tsx`, which
 * still reads `packaging-and-processing-equipment.ts` for its copy), kept as a redirect. The page
 * renders nothing and, once mounted in the browser, sends the visitor there. It is a browser-side
 * redirect, not an HTTP one: the static export has no redirects (`next.config.js`), so this page's
 * effect sets `window.location.href`. It has no `getStaticProps`, so unlike the industry pages it
 * is built for every brand.
 */
import React from "react";

/** Redirects to the Industrial Automation page on mount; see the file header. */
export default () => {
	React.useEffect(() => {
		//redirect from old url to new url
		window.location.href = "/metal-solutions/industries/industrial-automation";
	}, []);
	return <></>;
};
